<div class="w-full py-3">
  <div class="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-2">
    <div class="col-span-4 sm:col-span-4 lg:col-span-1 bg-[#E6EFFF] rounded-[5px] p-2 order-2 lg:order-1">
      <div class="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-4 gap-2 sm:gap-2.5">
        <div class="col-span-1">
          <div class="relative max-w-sm">
            <input datepicker datepicker-autohide id="billDate" type="text"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:bg-[#121212] dark:text-white dark:border-gray-600 focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder="" (focus)="setPlaceholder('billDate')" (blur)="clearPlaceholder('billDate')"
              (input)="onDateInput('billDate', $event)" [placeholder]="placeholders.billDate" />
            <div class="absolute inset-y-0 end-0 flex items-center pe-1 pointer-events-none">
              <svg class="size-6" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.9773 3.67371H4.02272C3.48663 3.67491 2.97284 3.8884 2.59376 4.26748C2.21469 4.64655 2.0012 5.16034 2 5.69644V20.651C2.0012 21.1871 2.21469 21.7009 2.59376 22.0799C2.97284 22.459 3.48663 22.6725 4.02272 22.6737H18.9773C19.5134 22.6725 20.0272 22.459 20.4062 22.0799C20.7853 21.7009 20.9988 21.1871 21 20.651V5.69644C20.9988 5.16034 20.7853 4.64655 20.4062 4.26748C20.0272 3.8884 19.5134 3.67491 18.9773 3.67371Z"
                  stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.06836 9.59113H10.8865" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.06836 13.2744H16.5002" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M8.56836 2.5V6.44491" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M14.4326 2.5V6.44491" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
              </svg>
            </div>
            <label for="billDate"
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-[#121212]  px-1.5 peer-focus:px-1.5 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Bill
              Date</label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative max-w-sm">
            <input datepicker datepicker-autohide id="mfdDate" type="text"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:bg-[#121212] dark:text-white dark:border-gray-600 focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder="" (focus)="setPlaceholder('mfdDate')" (blur)="clearPlaceholder('mfdDate')"
              (input)="onDateInput('mfdDate', $event)" [placeholder]="placeholders.mfdDate" />
            <div class="absolute inset-y-0 end-0 flex items-center pe-1 pointer-events-none">
              <svg class="size-6" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.9773 3.67371H4.02272C3.48663 3.67491 2.97284 3.8884 2.59376 4.26748C2.21469 4.64655 2.0012 5.16034 2 5.69644V20.651C2.0012 21.1871 2.21469 21.7009 2.59376 22.0799C2.97284 22.459 3.48663 22.6725 4.02272 22.6737H18.9773C19.5134 22.6725 20.0272 22.459 20.4062 22.0799C20.7853 21.7009 20.9988 21.1871 21 20.651V5.69644C20.9988 5.16034 20.7853 4.64655 20.4062 4.26748C20.0272 3.8884 19.5134 3.67491 18.9773 3.67371Z"
                  stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.06836 9.59113H10.8865" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.06836 13.2744H16.5002" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M8.56836 2.5V6.44491" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M14.4326 2.5V6.44491" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
              </svg>
            </div>
            <label for="mfdDate"
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-[#121212] px-1.5 peer-focus:px-1.5 peer-focus:text-c19725  peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">MFD
              Date</label>
          </div>
        </div>

        <div class="col-span-1">
          <app-custom-select label="Firm Name" [options]="firmTypes" [(selected)]="selectedFirm" selectId="firmTypes">
          </app-custom-select>
        </div>

        <div class="col-span-1">
          <app-custom-select label="Brand/Seller Name" [options]="brandSeller"
            [(selected)]="selectedBrandseller" selectId="sellerTypes">
          </app-custom-select>
        </div>
      </div>
    </div>
    <div class="col-span-4 sm:col-span-4 lg:col-span-1 order-1 lg:order-2">
      <div class="flex items-center justify-end gap-2 mb-4 md:mb-0">
        <div class="w-[300px] lg:w-[300px] flex justify-end items-center ms-auto">
          <a routerLink="#"
            routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
            [routerLinkActiveOptions]="{ exact: true }"
            class="flex-1 px-4 py-1 rounded-tl-[5px] rounded-bl-[5px] border-[0.50px] border-[#D9D9D9] flex justify-center items-center text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
            Wholesale
          </a>

          <a routerLink="/add-stock/add-cad-stock"
            routerLinkActive="bg-c19725 text-white font-medium outline-c19725 hover:bg-c19725 hover:text-white"
            class="flex-1 px-4 py-1 rounded-tr-[5px] rounded-br-[5px] border-[0.50px] border-[#D9D9D9] flex justify-center items-center text-[#898989] text-sm sm:text-sm lg:text-base hover:bg-[#f6f1cb] hover:text-black">
            Retail
          </a>
        </div>
        <a href="#"
          class="w-28 px-4 py-1 rounded-[5px] border-[0.50px] border-[#BB0000] flex justify-center items-center text-white bg-[#BB0000] text-sm sm:text-sm lg:text-base hover:bg-white hover:text-[#BB0000] hover:shadow-lg">
          <img class="size-4 me-2" src="/assets/images/stock/youtube.png" alt="youtube" />
          Help
        </a>
      </div>
    </div>
  </div>
  <div class="w-full grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-2 sm:gap-2.5 mt-3">
    <div class="col-span-1 w-full bg-[#EAF2F7] p-3 rounded-md">
      <div class="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-14 gap-2 sm:gap-2.5">
        <div class="col-span-4 sm:col-span-2 lg:col-span-7">
          <div class="flex items-center">
            <app-custom-select class="rounded-r-none w-full" label="Metal Name" [options]="metalTypes"
              [(selected)]="selectedMetal" selectId="metalTypes">
            </app-custom-select>

            <div class="relative w-full">
              <input type="text" id="" placeholder=" "
                class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer" /><label
                for=""
                class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Rate</label>
            </div>
          </div>
        </div>

        <div class="col-span-4 sm:col-span-3 lg:col-span-7">
          <div class="flex items-center">
            <div class="relative w-full">
              <input type="text" id="" placeholder=" "
                class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-l-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
                for=""
                class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Unique
                Code</label>
            </div>

            <div class="relative w-full">
              <input type="text" id="" placeholder=" "
                class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-r-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
                for=""
                class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Style
                Code</label>
            </div>
          </div>
        </div>


        <div class="col-span-2 sm:col-span-1 lg:col-span-3">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Barcode
            </label>
          </div>
        </div>

        <div class="col-span-2 sm:col-span-1 lg:col-span-2">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">HUID</label>
          </div>
        </div>



        <div class="col-span-2 sm:col-span-1 lg:col-span-3">
          <app-custom-select label="Item Cate." [options]="itemCategory"  [(selected)]="selectedItem"
            selectId="itemCategory">
          </app-custom-select>
        </div>

        <div class="col-span-2 sm:col-span-2 lg:col-span-3">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Item
              Name
            </label>
          </div>
        </div>

        <div class="col-span-2 sm:col-span-2 lg:col-span-3">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Cert.
              No.
            </label>
          </div>
        </div>


      </div>
    </div>

    <div class="col-span-1 w-full bg-[#FDF5F5] p-3 rounded-md">
      <div class="grid grid-cols-2 sm:grid-cols-8 md:grid-cols-16 lg:grid-cols-8 gap-2 sm:gap-2.5">

        <div class="col-span-1 sm:col-span-2">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Qty</label>
          </div>
        </div>

        <div class="col-span-1 sm:col-span-2">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">GS
              WT</label>
          </div>
        </div>

        <div class="col-span-1 sm:col-span-2">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-[#fafafa] rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-[#fafafa] dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">NTWT</label>
          </div>
        </div>

        <div class="col-span-1 sm:col-span-2">
          <app-custom-select label="Unit" [options]="unitTypes"  [(selected)]="selectedUnit"
            selectId="selectedUnit">
          </app-custom-select>
        </div>

        <div class="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-2">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Purity
              Code</label>
          </div>
        </div>

        <div class="col-span-1 sm:col-span-2">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Purity</label>
          </div>
        </div>

        <div class="col-span-1 sm:col-span-2">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-[#fafafa] rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-[#fafafa] dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">FN
              WT</label>
          </div>
        </div>

        <div class="col-span-1 sm:col-span-2">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Other
              Info
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-span-1 lg:col-span-2 2xl:col-span-1 w-full bg-[#EEFFF4] p-3 rounded-md">
      <div class="grid grid-cols-3 sm:grid-cols-6 md:grid-cols-12 2xl:grid-cols-6 gap-2 sm:gap-2.5">
        <div class="col-span-2 sm:col-span-3">
          <div class="flex items-center">
            <div class="relative">
              <input type="text" id="" placeholder=" "
                class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-l-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
                for=""
                class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Lab
                Chrg</label>
            </div>
            <div class="relative">
              <input type="text" id="" placeholder=" "
                class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-r-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
                for=""
                class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Mkg
                Chrg</label>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <app-custom-select label="Unit" [options]="unitTypes"  [(selected)]="selectedUnit"
            selectId="selectedUnit">
          </app-custom-select>
        </div>

        <div class="col-span-1 sm:col-span-2">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Metal
              Valuation</label>
          </div>
        </div>

        <div class="col-span-2 sm:col-span-3">
          <div class="flex items-center">
            <div class="relative">
              <input type="text" id="" placeholder=" "
                class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-l-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
                for=""
                class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">HM
                Chrg</label>
            </div>
            <div class="relative">
              <input type="text" id="" placeholder=" "
                class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-r-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
                for=""
                class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Oth
                Chrg</label>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <app-custom-select label="Unit" [options]="unitTypes" [(selected)]="selectedUnit"
            selectId="selectedUnit">
          </app-custom-select>
        </div>

        <div class="col-span-2 sm:col-span-2">
          <div class="relative">
            <input type="text" id="" placeholder=" "
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer text-right" /><label
              for=""
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Total
              Amount</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- stone form -->
  <app-stone-form *ngIf="isFormVisible"></app-stone-form>

  <div class="flex flex-col sm:flex-row items-center px-2 py-2 w-full flex-wrap gap-y-4">

    <!-- Left group: Add Jewellery and Add Stone -->
    <div class="flex items-center gap-6 min-w-[260px] sm:min-w-[300px] flex-shrink-0">
      <!-- Add Jewellery -->
      <div class="cursor-pointer flex items-center text-[#B7791F] hover:text-[#A16207] transition whitespace-nowrap">
        <img class="w-5 h-5 me-1.5" src="/assets/images/stock/gold-ring.png" alt="ring" />
        <span class="text-sm font-medium">Add Jewellery</span>
      </div>

      <!-- Add Stone -->
      <div (click)="toggleForm()"
        class="cursor-pointer flex items-center text-[#5B21B6] hover:text-[#4c1c9b] transition whitespace-nowrap">
        <img class="w-5 h-5 me-1.5" src="/assets/images/stock/gold-diamond.png" alt="diamond" />
        <span class="text-sm font-medium">Add Stone</span>
      </div>
    </div>


    <!-- Icons group: Shifted right by 100px and slightly upward -->
    <div class="relative flex-shrink-0 mt-[-8px] left-[100px]">
      <div class="flex items-center gap-8 text-gray-600">
        <a href="#" class="hover:text-indigo-600 transition flex items-center gap-2">
          <img class="w-5 h-5" src="/assets/images/stock/storage.png" alt="storage" />
          <span>Upload Image</span>
        </a>
        <a href="#" class="hover:text-indigo-600 transition flex items-center gap-2">
          <img class="w-5 h-5" src="/assets/images/stock/webcam.png" alt="webcam" />
          <span>Capture Image</span>
        </a>
      </div>
    </div>



    <!-- Right group: Checkboxes + Totals -->
    <div class="flex flex-col sm:flex-row w-full sm:w-auto justify-end items-center gap-4 sm:ms-auto mt-6 sm:mt-0">

      <!-- Checkboxes group -->
      <div class="flex flex-wrap items-center gap-3 justify-center sm:justify-start">
        <div class="flex items-center px-2 py-2 text-xs sm:text-sm text-gray-700 font-normal whitespace-nowrap">
          <input type="checkbox"  autocomplete="off"
            class="cursor-pointer size-4 me-1.5 text-c19725 border-2 border-c19725 rounded focus:ring-1 focus:ring-c19725" />
          <span>BIS Hallmark</span>
        </div>
        <div class="flex items-center px-2 py-2 text-xs sm:text-sm text-gray-700 font-normal whitespace-nowrap">
          <input type="checkbox"  autocomplete="off"
            class="cursor-pointer size-4 me-1.5 text-c19725 border-2 border-c19725 rounded focus:ring-1 focus:ring-c19725" />
          <span>Add Detail</span>
        </div>
        <div class="flex items-center px-2 py-2 text-xs sm:text-sm text-gray-700 font-normal whitespace-nowrap">
          <input type="checkbox"  autocomplete="off"
            class="cursor-pointer size-4 me-1.5 text-c19725 border-2 border-c19725 rounded focus:ring-1 focus:ring-c19725" />
          <span>Add Ecom</span>
        </div>
        <div class="flex items-center px-2 py-2 text-xs sm:text-sm text-gray-700 font-normal whitespace-nowrap">
          <input type="checkbox"  autocomplete="off"
            class="cursor-pointer size-4 me-1.5 text-c19725 border-2 border-c19725 rounded focus:ring-1 focus:ring-c19725" />
          <span>Fix MRP</span>
        </div>
      </div>

      <!-- Amount box -->
      <div
        class="w-max flex items-center justify-end py-3 px-3 border border-blue-gray-100 bg-white rounded-lg shadow-sm mt-4 sm:mt-0">

        <!-- Taxable Amount -->
        <div class="relative px-4">
          <p class="text-xs text-blue-gray-500 absolute -top-5 left-0 bg-white px-1">Taxable Amount</p>
          <p class="text-sm text-blue-gray-700 font-medium">₹ 48,500.00</p>
        </div>

        <!-- GST Amount -->
        <div class="relative px-4 border-l border-blue-gray-100">
          <p class="text-xs text-green-600 absolute -top-5 left-4 bg-white px-1">GST Amount</p>
          <p class="text-sm text-green-600 font-medium"><span class="mr-1">3%</span>| ₹ 1,500.00</p>
        </div>

        <!-- Equals -->
        <p class="text-blue-gray-400 font-bold text-xl mx-2">=</p>

<div class="relative px-4">
<p class="text-xs text-[#0f1e57] absolute -top-5 left-0 bg-white px-1 font-medium">
  Final Amount
</p>
<p class="text-xl font-semibold text-[#00059f] text-right  px-1 rounded">
  ₹ 50,000,000.00
</p>
</div>



      </div>
    </div>
  </div>
</div>


<div class="sm:flex items-center flex-wrap justify-center mt-6 space-y-2 sm:space-y-0 sm:space-x-2 lg:space-x-4">



  <button type="button"
      class="h-[42px] w-[160px] font-bold text-[15px] mt-[5px] mb-[5px]
             rounded-[5px] text-[#006400] bg-[#D8F6D8]
             border border-[#76c176]
             flex items-center justify-center gap-1 text-center
             transition-all duration-300 ease-in-out
             hover:bg-[#c8eec8] hover:border-[#5cae5c] group">

      <img class="w-6 h-6 group-hover:rotate-0 transition-transform duration-300"
           src="https://next.omunim.in/2/images/img/stock.png" alt="gold" />

      <span class="transition-transform duration-300 group-hover:translate-x-1">
        ADD STOCK
      </span>
  </button>



  <button type="button"
    class="h-[42px] w-[160px] font-bold text-[15px] mt-[5px] mb-[5px]
    rounded-[5px]
           bg-[#BED8FD] border border-[#808bee] rounded-[5px]
           flex items-center justify-center gap-1
           text-[#000080]
           hover:bg-[#9AB3F5] hover:border hover:border-[#5C6AC4]
           group transition-all duration-300 ease-in-out">

    <img class="w-5 h-5 group-hover:rotate-0 transition-transform duration-300"
         src="https://cdn-icons-png.flaticon.com/128/3502/3502463.png"
         alt="existing" />

    <span class="transition-transform duration-300 group-hover:translate-x-1">
      EXISTING ITEM
    </span>
  </button>




  <button type="button"
    class="h-[42px] w-[180px] font-bold text-[15px] mt-[5px] mb-[5px]
    rounded-[5px]
           bg-[#FFE6BE] text-[#AA6600]
           rounded-[5px] border border-[#ffb139]
           flex items-center justify-center gap-1
           transition-all duration-300 ease-in-out
           hover:bg-[#FFD69E] hover:border-[#e6a800] hover:text-[#AA6600]
           group">
    <img class="w-5 h-5 group-hover:rotate-0 transition-transform duration-300"
         src="https://img.icons8.com/?size=64&id=xmSQdgXmNPJJ&format=png" alt="cash" />
    <span class="transition-transform duration-300 group-hover:translate-x-1">
      PURCHASE ON CASH
    </span>
  </button>



  <button type="button"
    class="h-[42px] w-[160px] font-bold text-[15px] mt-[5px] mb-[5px]
    rounded-[5px]
           bg-[#cee6ff] border border-[#808bee] rounded-[5px]
           flex items-center justify-center gap-1
           text-[#0821a4]
           hover:bg-[#c0d4ef] hover:text-[#0821a4] hover:border-[#083d6d]
           group transition-all duration-300 ease-in-out">

    <img class="w-5 h-5 group-hover:rotate-0 transition-transform duration-300"
    src="/assets/images/stock/BIS HallmarkPNG/PNG/BIS-Hallmark-M.png"
         alt="hallmark" />

    <span class="transition-transform duration-300 group-hover:translate-x-1">HALLMARKING</span>
  </button>

  </div>
